import { createSelector } from 'reselect';

export const getUserPermissions = (state) => state.userPermissions || {};
export const getActivityPermissions = (state) => state.activityPermissions || [];

export const getUserPermissionsByUserId = createSelector(
    [getUserPermissions, (state, userId) => userId],
    (permissions, userId) => permissions[userId] || {}
);

export const getActivityPermissionsById = createSelector(
    [getActivityPermissions, (state, activityId) => activityId],
    (activities, activityId) => activities.find(activity => activity.id === activityId)
);
